// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2552":"ecffe5a2","3445":"a49a3b5c"}[chunkId] + ".chunk.css";
};